module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/responsive-wrap/responsive-wrap.component.css
// module id = ./src/app/examples/responsive-wrap/responsive-wrap.component.css
// module chunks = main